import { getConfiguration, getDirectApi } from "mytours-read-common";
import { getUAParser } from '../../services/uaParser';

// Deep Linking Apple Enabled, declared in views/layouts/mobile_web.html.erb
declare const deepLinkingAppleEnabled: boolean

interface NetworkInformation {
	type: 'bluetooth' | 'cellular' | 'ethernet' | 'none' | 'wifi' | 'wimax' | 'other' | 'unknown';
}

declare global {
	interface Navigator {
		connection?: NetworkInformation;
		mozConnection?: NetworkInformation;
		webkitConnection?: NetworkInformation;
	}
}

function harmonizeConnectionType(type: NetworkInformation['type']): 'cellular' | 'wifi' | '' {
	switch (type) {
		case 'wimax':
			return 'cellular';
		case 'cellular':
			return 'cellular'
		case 'wifi':
			return 'wifi'
		default:
			return ''
	}
}

function storeDeferredDeepLinkingURL() {
	const platform = getConfiguration().getPlatform()
	const deviceUUID = getConfiguration().getDeviceUUID()

	const result = getUAParser().getResult()
	const isAndroid = result.os.name === 'Android';

	const connection = navigator.connection ||
		navigator.mozConnection ||
		navigator.webkitConnection;

	getDirectApi().storeDeepLinkURL(platform, deviceUUID, {
		locale: isAndroid ? "" : navigator.language.replace('-', '_'),
		screen_scale: window.devicePixelRatio.toFixed(1),
		screen_height: isAndroid ? undefined : window.outerHeight,
		country: isAndroid ? "" : (new Intl.Locale(navigator.language)).region,
		os_name: result.os.name,
		language: isAndroid ? "" : (new Intl.Locale(navigator.language)).language,
		os_version: isAndroid ? "" : result.os.version,
		brand_name: isAndroid ? "" : result.device.vendor,
		screen_width: window.outerWidth,
		connection_type: isAndroid ? harmonizeConnectionType(connection?.type) : "",
		model_name: isAndroid ? "" : result.device.model,
		url: window.location.href,
	})
}

export function storeDeferredDeepLinkingURLIfNeeded() {
	if (deepLinkingAppleEnabled) {
		storeDeferredDeepLinkingURL()
	}
}
